import { FILTER_LOGICAL_OPERATOR, type FilterLogicalOperator, type SingleFilter } from './types';

/** One condition of a filter; `negated` turns "is" into "is not" (no match of the filter). */
export interface FilterCondition extends SingleFilter {
  negated?: boolean;
}

/** Conditions and nested groups joined by one logical operator. */
export interface FilterGroup {
  operator: FilterLogicalOperator;
  nodes: FilterNode[];
}

export type FilterNode = FilterCondition | FilterGroup;

export function isFilterGroup(node: FilterNode): node is FilterGroup {
  return 'nodes' in node;
}

export function groupOf(operator: FilterLogicalOperator, nodes: FilterNode[]): FilterGroup {
  return { operator, nodes };
}

/** A group without conditions: every element matches it. */
export const MATCH_ALL_FILTER_GROUP: FilterGroup = groupOf(FILTER_LOGICAL_OPERATOR.AND, []);
